// ----------- collection  list   img --------

document.addEventListener("DOMContentLoaded", function () {

  const iconURL =
    "https://cdn.shopify.com/s/files/1/0820/2869/1736/files/checkiconfordesk.png?v=1763640965";

  // Target ONLY collection banner list items
  const listItems = document.querySelectorAll(".collection-hero li");

  listItems.forEach(li => {
    
    // Avoid duplicate icons if JS reloads
    if (li.querySelector("img.check-icon")) return;

    const icon = document.createElement("img");
    icon.src = iconURL;
    icon.className = "check-icon";
    icon.alt = "check";

    // Add icon before text
    li.prepend(icon);
  });
});



document.addEventListener("DOMContentLoaded", function () {

  const certURL = window.collectionCertificate;
  if (!certURL || certURL === "") return;   // metafield empty → do nothing

  // Your certificate thumbnail image
  const certificateThumb = "https://cdn.shopify.com/s/files/1/0820/2869/1736/files/certificate-thumbnail.png?v=1764335319";

  // Grab Shopify thumbnail slider UL
  const slider = document.querySelector("[id^='Slider-Thumbnails']");
  if (!slider) return;

  // Create new LI
  let li = document.createElement("li");
  li.className = "thumbnail-list__item slider__slide";
  li.style.cursor = "pointer";

  li.innerHTML = `
    <button class="thumbnail global-media-settings global-media-settings--no-shadow">
      <img 
        src="${certificateThumb}" 
        alt="Certificate"
        style="width:100%; border-radius:6px;"
      >
    </button>
  `;

  // On click → open metafield certificate
  li.addEventListener("click", function () {
    window.open(certURL, "_blank");
  });

  // Add to end of slider
  slider.appendChild(li);

});


// --------


document.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll(".top-inline-menu a");
  
  let hasActive = false;
  
  // Check if Shopify already set any active
  links.forEach(link => {
    if (link.classList.contains("active")) {
      hasActive = true;
    }
  });

  // If no menu is active -> set Gemstones active
  if (!hasActive) {
    links.forEach(link => {
      if (link.textContent.trim().toLowerCase() === "gemstones") {
        link.classList.add("active");
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll(".top-inline-menu a");

  links.forEach(link => {
    if (link.textContent.trim().toLowerCase() === "rudraksha") {
      link.setAttribute("target", "_blank");
    }
  });
});



// document.addEventListener("DOMContentLoaded", function() {

//   const menu = document.querySelector(".top-inline-menu ul");

//   if (menu) {

//     const li = document.createElement("li");

//     li.innerHTML = `
//       <div class="currency-selector top-phone-btn">
//         <a href="tel:+919953660004">
//         <span> <img src="https://cdn.shopify.com/s/files/1/0794/0820/1965/files/5_1.png?v=1771313187" class="phone-call"> </span> +91-9953660004
//         </a>
//       </div>
//     `;

//     menu.appendChild(li);

//   }

// });



// ------ remove duplicate phone number (keeps the one next to country selector) ----

document.addEventListener("DOMContentLoaded", function () {
  const mine = document.querySelector(".top-phone-localization .top-phone-btn");
  if (!mine) return;

  document.querySelectorAll(".top-inline-menu .top-phone-btn").forEach(function (p) {
    if (p !== mine) {
      const li = p.closest("li");
      if (li) li.remove();
    }
  });
});



// ------- disclaimer code  ----

document.addEventListener("DOMContentLoaded", function () {

  const selectedText = document.getElementById("bgm-selected-text");
  const ringDisclaimer = document.getElementById("bgm-ring-disclaimer");

  // ONLY top buying options
  document.querySelectorAll(".bgm-buying-options .bgm-option").forEach(option => {
    option.addEventListener("click", function () {

      const selectedOption = this.getAttribute("data-option");

      if (selectedOption === "ring") {
        selectedText.textContent = "Ring";
        ringDisclaimer.style.display = "block";
      }

      if (selectedOption === "pendant") {
        selectedText.textContent = "Pendant";
        ringDisclaimer.style.display = "block";
      }

      if (selectedOption === "loose") {
        ringDisclaimer.style.display = "none";
      }

    });
  });

  // P click → hide disclaimer
 document.addEventListener("DOMContentLoaded", function () {

  const ringDisclaimer = document.getElementById("ringDisclaimer");
  const btn = document.getElementById("bgm-hide-disclaimer");

  if(btn && ringDisclaimer){
    btn.addEventListener("click", function () {
      ringDisclaimer.style.display = "none";
    });
  }

});

});

// ----------- products sticky -------------------

document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("click", function (e) {

    /* Open modal */
    const openBtn = e.target.closest(".video-fullscreen-btn");
    if (openBtn) {
      document.body.classList.add("video-modal-open");
    }

    /* Close modal */
    const closeBtn = e.target.closest(".video-modal-close");
    if (closeBtn) {
      document.body.classList.remove("video-modal-open");
    }

    /* Click outside modal */
    if (e.target.classList.contains("video-modal")) {
      document.body.classList.remove("video-modal-open");
    }
  });

  /* ESC close */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.body.classList.remove("video-modal-open");
    }
  });

});



// collection title



// ------------------  new js for brahma gems -----


document.addEventListener("DOMContentLoaded", function () {

  var blocks = document.querySelectorAll('.footer-block');

  blocks.forEach(function(block){

    var heading = block.querySelector('.footer-block__heading');

    if (heading && heading.textContent.trim() === "Help?") {

      if (!block.querySelector('.whatsapp-footer-btn')) {

        var btn = document.createElement("a");
        btn.href = "https://wa.me/919873088568";
        btn.target = "_blank";
        btn.className = "whatsapp-footer-btn";

        // Create Image
        var img = document.createElement("img");
        img.src = "https://cdn.shopify.com/s/files/1/0794/0820/1965/files/whatsapp_1.png?v=1771221319";
        img.alt = "WhatsApp";

        // Create Text
        var text = document.createTextNode(" connect now for more info");

        btn.appendChild(img);
        btn.appendChild(text);

        block.appendChild(btn);
      }
    }

  });

});



// ------ animited text autoplay  ----


// ------ animated text autoplay (desktop + mobile) ----
document.addEventListener("DOMContentLoaded", function () {
  const fixedText = "Search for ";
  const words = [
    "Ruby..",
    "Pukhraj..",
    "Neelam..",
    "Blue Sapphire..",
    "Certified Gemstones.."
  ];

  const inputs = document.querySelectorAll(".search-input");
  if (!inputs.length) return;

  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;

  function typeEffect() {
    const currentWord = words[wordIndex];
    charIndex += isDeleting ? -1 : 1;

    const text = fixedText + currentWord.substring(0, charIndex);
    inputs.forEach(function (input) {
      input.setAttribute("placeholder", text);
    });

    let delay = isDeleting ? 50 : 100;

    if (!isDeleting && charIndex === currentWord.length) {
      isDeleting = true;
      delay = 1000; // word poora hone ke baad pause
    } else if (isDeleting && charIndex === 0) {
      isDeleting = false;
      wordIndex = (wordIndex + 1) % words.length;
      delay = 300;
    }

    setTimeout(typeEffect, delay);
  }

  typeEffect();
});


// -- foooter logo ------------


document.addEventListener("DOMContentLoaded", function() {

  const container = document.querySelector(".footer-block__details-content.rte");
  if (!container) return;

  const paragraphs = container.querySelectorAll("p");

  let newHTML = "";

  paragraphs.forEach((p, index) => {
    const text = p.textContent.trim();
    if (!text) return;

    let icon = "";

    if (index === 0)
      icon = '<img src="https://cdn.shopify.com/s/files/1/0794/0820/1965/files/5_2.png?v=1771928600" class="footer-icon">';

    if (index === 1)
      icon = '<img src="https://cdn.shopify.com/s/files/1/0794/0820/1965/files/9_1.png?v=1771929018" class="footer-icon phone-icon">';

    if (index === 2)
      icon = '<img src="https://cdn.shopify.com/s/files/1/0794/0820/1965/files/7_1.png?v=1771929295" class="footer-icon">';

    if (index === 3)
      icon = '<img src="https://cdn.shopify.com/s/files/1/0794/0820/1965/files/7_1.png?v=1771929295" class="footer-icon">';

    newHTML += `<div class="contact-row">${icon} ${text}</div>`;
  });

  container.innerHTML = newHTML;

});


document.addEventListener("DOMContentLoaded", function() {

  const contactContainer = document.querySelector(".footer-block__details-content.rte");
  const socialContainer = document.querySelector(".footer__list-social");

  if (!contactContainer || !socialContainer) return;

  // Move social icons below contact info
  contactContainer.appendChild(socialContainer);

});



// ----- menu ----



// jewlery first image call with js  

(function () {
    var cachedImgSrc = null;
    var cachedImgSrcset = null;
    var cachedImgAlt = '';

    function getFirstThumb() {
      return document.querySelector('.thumbnail-list__item img');
    }

    function getTargetSpan() {
      var targetButton = document.querySelector(
        '.krt-jw__option[data-handle="loose-gemstone"]'
      );
      return targetButton
        ? targetButton.querySelector('.krt-jw__option-img')
        : null;
    }

    function buildImg() {
      var img = document.createElement('img');
      img.src = cachedImgSrc;
      if (cachedImgSrcset) img.srcset = cachedImgSrcset;
      img.alt = cachedImgAlt;
      img.loading = 'lazy';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      img.style.display = 'block';
      return img;
    }

    function ensureImageInSpan() {
      if (!cachedImgSrc) {
        var firstThumb = getFirstThumb();
        if (!firstThumb) return;

        var src = firstThumb.getAttribute('src');
        if (!src) return;

        cachedImgSrc = src.indexOf('//') === 0 ? 'https:' + src : src;
        cachedImgSrcset = firstThumb.getAttribute('srcset');
        cachedImgAlt = firstThumb.getAttribute('alt') || '';
      }

      var targetSpan = getTargetSpan();
      if (!targetSpan) return;

      if (!targetSpan.querySelector('img')) {
        targetSpan.appendChild(buildImg());
      }
    }

    var debounceTimer = null;
    function scheduleCheck() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(ensureImageInSpan, 30);
    }

    function init() {
      ensureImageInSpan();

      var observer = new MutationObserver(function () {
        scheduleCheck();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-pressed']
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function () {
      cachedImgSrc = null;
      ensureImageInSpan();
    });
  })();
